module.exports = __webpack_public_path__ + "static/media/wavy_right2.5fb85ed5.svg";